import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5d67fb8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d5d67fb8&prod&lang=scss"
import style1 from "./style.scss?vue&type=style&index=1&id=d5d67fb8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d67fb8",
  null
  
)

export default component.exports